import React from 'react';
import type { TourStep } from '@digiwedge/tour-react';

const SELECTORS = {
  header: '[data-tour-step="teetime-header"]',
  searchInput: '[data-tour-id="teetime-search-input"]',
  searchButton: '[data-tour-id="teetime-search-submit"]',
  searchResults: '[data-tour-id="teetime-search-results"]',
} as const;

export function createSearchTourSteps(): TourStep[] {
  if (typeof document === 'undefined') {
    return [];
  }

  const steps: TourStep[] = [];

  const header = document.querySelector(SELECTORS.header);
  if (header instanceof HTMLElement) {
    steps.push({
      id: 'teetime-nav-overview',
      target: header,
      content: (
        <>
          The navigation bar keeps shortcuts to bookings, your profile, and settings. You can come
          back here any time.
        </>
      ),
      spotlightPadding: 12,
    });
  }

  const searchInput = document.querySelector(SELECTORS.searchInput);
  if (searchInput instanceof HTMLElement) {
    steps.push({
      id: 'teetime-search-input',
      target: searchInput,
      content: (
        <>
          Start by choosing a club or location. Adjust the details above to set your preferred date,
          group size, and number of holes.
        </>
      ),
      spotlightPadding: 12,
      allowInteraction: true,
    });
  }

  const searchButton = document.querySelector(SELECTORS.searchButton);
  if (searchButton instanceof HTMLElement) {
    steps.push({
      id: 'teetime-search-submit',
      target: searchButton,
      content: <>Ready? Hit Search to pull the latest availability for your filters.</>,
      spotlightPadding: 10,
    });
  }

  const results = document.querySelector(SELECTORS.searchResults);
  if (results instanceof HTMLElement) {
    steps.push({
      id: 'teetime-search-results',
      target: results,
      content: (
        <>
          Available tee times appear here. Review the slots, adjust filters if needed, and select
          the time that suits your group.
        </>
      ),
      spotlightPadding: 20,
      allowInteraction: true,
    });
  }

  return steps;
}

export function searchTourSteps(): TourStep[] {
  return createSearchTourSteps();
}
